import { lightBlue } from "../../colors";

const initialState = {
  isShown: true,
  bottomNavigation: true,
  backButtonShown: false,
  backScreen: null,
  backScreenProps: null,
  parent: "mother",
  notifications: 0,
  background: lightBlue,
  backFunction: null,
};
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "CHANGE_HEADER_COLOR":
      return { ...state, background: action.color };
    case "SHOW_BACK_BUTTON":
      return {
        ...state,
        backButtonShown: true,
        backScreen: action.backScreen,
        backScreenProps: null,
      };
    case "SHOW_BACK_BUTTON_WITH_PROPS":
      return {
        ...state,
        backButtonShown: true,
        backScreen: action.backScreen,
        backScreenProps: action.props,
      };
      case "SHOW_BACK_BUTTON_WITH_FUNCTION":
        return {
          ...state,
          backButtonShown: true,
          backFunction:action.function
        };
      
    case "HIDE_BACK_BUTTON":
      return {
        ...state,
        backButtonShown: false,
        bottomNavigation: true,
        backScreenProps: null,
      };
    case "SHOW_BOTTOM_NAVIGATION":
      return { ...state, bottomNavigation: true };
    case "HIDE_BOTTOM_NAVIGATION":
      return { ...state, bottomNavigation: false };
    default:
      return state;
  }
}
